'use client';

import { motion } from 'motion/react';

export default function CTA() {
  return (
    <section className="bg-[#0a0a0a] py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-5xl">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative overflow-hidden rounded-2xl border border-zinc-800 bg-[#141414] px-6 py-20 text-center md:px-12"
        >
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#b4ff00]/5 via-transparent to-transparent" />
          
          <div className="relative z-10">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mb-6 text-4xl font-black tracking-tight text-white md:text-5xl lg:text-6xl"
            >
              Build your competition ecosystem <br className="hidden md:block" />
              <span className="text-[#b4ff00]">with clarity.</span>
            </motion.h2>
            
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="mx-auto mb-10 max-w-2xl text-lg text-zinc-400"
            >
              Take control of your structural identity. Launch your professional arena today.
            </motion.p>
            
            <motion.button
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="rounded-sm bg-[#b4ff00] px-10 py-4 text-sm font-bold text-black transition-transform hover:scale-105"
            >
              Get Started Now
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
